import { CardHeader, Chip } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface GenericCardHeaderProps {
  className?: string;
  avatar?: React.ReactNode;
  title?: React.ReactNode;
  action?: React.ReactNode;
}

const GenericCardHeaderImpl: React.FC<GenericCardHeaderProps> = ({
  className,
  avatar,
  title,
  action,
}) => {
  return (
    <CardHeader
      className={className}
      avatar={avatar}
      title={title}
      action={action}
    />
  );
};

export const GenericCardHeader = muiStyled(GenericCardHeaderImpl)(
  ({ theme }) => css`
    padding: ${theme.spacing(4)} ${theme.spacing(4)} 0;
  `
);
